import React from "react";
import {
    Box,
    Container,
    Typography,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@mui/material";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

export default function Privacidade() {
    return (
        <Box sx={{ bgcolor: "#ffffff", overflowX: "hidden", pb: 8 }}>
            <Box
                sx={{
                    bgcolor: "primary.main",
                    color: "white",
                    py: { xs: 6, md: 8 },
                    borderRadius: { xs: "0 0 20px 20px", md: "0 0 60px 60px" },
                    textAlign: "center",
                    boxShadow: 3,
                    mb: 6,
                }}
            >
                <Container maxWidth="md">
                    <SecurityOutlinedIcon sx={{ fontSize: 48, opacity: 0.9, mb: 1 }} />
                    <Typography variant="h3" component="h1" sx={{ fontWeight: 800, mb: 2, letterSpacing: "-0.03em" }}>
                        Política de Privacidade
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 400, opacity: 0.9, maxWidth: 600, mx: "auto", lineHeight: 1.6 }}>
                        Suas informações são tratadas com segurança e transparência. Saiba como coletamos, usamos e protegemos seus dados.
                    </Typography>
                </Container>
            </Box>

            <Container maxWidth="md">
                <Paper elevation={0} sx={{ p: { xs: 3, md: 4 }, borderRadius: 3, border: "1px solid", borderColor: "divider" }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: "primary.main", mb: 2 }}>
                        Dados que coletamos
                    </Typography>
                    <Typography variant="body1" color="#1e1e1e" sx={{ lineHeight: 1.8, mb: 2 }}>
                        Para realizar pedidos, criar conta e melhorar sua experiência, podemos coletar: nome, e-mail, telefone, CPF,
                        endereço de entrega, dados de pagamento (processados de forma segura por operadores certificados) e histórico
                        de navegação no site (cookies e tecnologias similares).
                    </Typography>

                    <Divider sx={{ my: 3 }} />

                    <Typography variant="h6" sx={{ fontWeight: 700, color: "primary.main", mb: 2 }}>
                        Finalidade do uso
                    </Typography>
                    <List dense>
                        {[
                            "Processar compras e entregas;",
                            "Comunicar sobre pedidos e ofertas (com seu consentimento);",
                            "Melhorar produtos, serviços e atendimento;",
                            "Cumprir obrigações legais e regulatórias.",
                        ].map((item, i) => (
                            <ListItem key={i} sx={{ py: 0.5 }}>
                                <ListItemIcon sx={{ minWidth: 36 }}>
                                    <LockOutlinedIcon color="primary" fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={item} primaryTypographyProps={{ variant: "body2", color: "#1e1e1e" }} />
                            </ListItem>
                        ))}
                    </List>

                    <Typography variant="body1" color="#1e1e1e" sx={{ lineHeight: 1.8, mt: 2 }}>
                        Não vendemos seus dados pessoais. O compartilhamento ocorre apenas com parceiros necessários ao processamento
                        de pagamentos e logística, sob contratos que garantem a proteção das informações.
                    </Typography>

                    <Divider sx={{ my: 3 }} />

                    <Typography variant="h6" sx={{ fontWeight: 700, color: "primary.main", mb: 2 }}>
                        Seus direitos (LGPD)
                    </Typography>
                    <Typography variant="body1" color="#1e1e1e" sx={{ lineHeight: 1.8 }}>
                        De acordo com a Lei Geral de Proteção de Dados (LGPD), você pode acessar, corrigir, excluir ou portar seus dados,
                        além de revogar consentimentos. Para exercer esses direitos, entre em contato pelo e-mail{" "}
                        <strong>emma.suporte@gmail.com</strong>.
                    </Typography>

                    <Typography variant="body2" color="#1e1e1e" sx={{ mt: 4, fontStyle: "italic" }}>
                        Esta política pode ser atualizada. Alterações relevantes serão comunicadas por e-mail ou aviso em nosso site.
                    </Typography>
                </Paper>
            </Container>
        </Box>
    );
}
